(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminQuoteDisplaySettingsController', AdminQuoteDisplaySettingsController);

    function AdminQuoteDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'quote_timeout',
                'quote_terms_text',
                'quote_terms_file',
                'quote_require_labour_and_materials',
                'budget_quotes'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
